var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.3337 15.9993C29.3337 23.3647 23.3643 29.3327 16.0003 29.3327C8.63633 29.3327 2.66699 23.3647 2.66699 15.9993C2.66699 8.63668 8.63633 2.66602 16.0003 2.66602C23.3643 2.66602 29.3337 8.63668 29.3337 15.9993Z",
    fill: "#3C7CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1605 16.8412C17.1605 17.4839 16.6365 18.0079 15.9938 18.0079C15.3511 18.0079 14.8271 17.4839 14.8271 16.8412V10.9479C14.8271 10.3052 15.3511 9.78125 15.9938 9.78125C16.6365 9.78125 17.1605 10.3052 17.1605 10.9479V16.8412ZM14.8338 21.0716C14.8338 20.429 15.3552 19.905 15.9938 19.905C16.6512 19.905 17.1738 20.429 17.1738 21.0716C17.1738 21.7143 16.6512 22.2383 16.0072 22.2383C15.3605 22.2383 14.8338 21.7143 14.8338 21.0716Z",
    fill: "#3C7CF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ba54ea319def87c554e3b8b9292e27b0.svg";
export { ForwardRef as ReactComponent };